export default [
    {
        "id": "blog",
        "plugin": "blog",
        "pluginId": 12,
        "name": "blog",
        "html": require('./blog/html').default
    }
]